import { render, staticRenderFns } from "./ChartsColumn.vue?vue&type=template&id=2fa53ae0&scoped=true&"
import script from "./ChartsColumn.vue?vue&type=script&lang=js&"
export * from "./ChartsColumn.vue?vue&type=script&lang=js&"
import style0 from "./ChartsColumn.vue?vue&type=style&index=0&id=2fa53ae0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa53ae0",
  null
  
)

export default component.exports